import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-lista-estado',
    templateUrl: './lista-estado.component.html',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ListaEstadoComponent {
  @Input() dados: any;
  @Input() mensagemCarregando = 'Consultando dados ...';
  @Input() mensagemErro = 'Ocorreu um erro na consulta.';
  @Input() mensagemVazio = 'Não existem dados para essa consulta.';
  @Input() imagemErro = '/assets/img/erro.png';
  @Input() imagemVazio = '/assets/img/vazio.png';
}
